import React, { Component } from 'react';
import styled from 'styled-components';
import NameReveal from './NameReveal';
import TitleReveal from './TitleReveal';
import Music from './Music';

const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: white;
  /* border: 1px solid blue; */
`;
const ButtonDownload = styled.button`
  z-index: 1;
  cursor: pointer;
  position: relative;
  width: 200px;
  height: 55px;
  text-align: center;
  padding: 0.61538462em 1em;
  vertical-align: middle;
  color: #fff;
  font-size: 1.12em;
  border: none;
  border-radius: 5px;
  background-color: #ffffff;
  background-image: linear-gradient(to top left, black 0 50%, transparent 50% 100%),
    linear-gradient(to top right, black 0 50%, transparent 50% 100%), linear-gradient(black 0 100%);
  background-size: 20% 100%, 20% 100%, 60% 100%;
  background-position: left top, right top, center top;
  background-repeat: no-repeat;
  &:after {
    content: '';
    display: block;
    visibility: hidden;
    width: 100%;
    background: rgba(255, 255, 255, 0.2);
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.7) 100%); /* Safari 5.1-6.0 */
    background: -o-linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.7) 100%
    ); /* Opera 11.1-12.0 */
    background: -moz-linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.7) 100%
    ); /* Firefox 3.6-15 */
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.7) 100%
    ); /* Standard syntax */

    left: -100%;
    top: 0;
    height: 100%;
    position: absolute;
    transition: none;
    -webkit-transition: none;
    -moz-transition: none;
    -o-transition: none;
    -ms-transition: none;
    -ms-transform: skewX(-20deg); /* IE 9 */
    -webkit-transform: skewX(-20deg); /* Safari */
    transform: skewX(-20deg);
  }
  &:hover::after {
    visibility: visible;
    left: 150%;
    transition: all 1s;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -o-transition: all 1s;
    -ms-transition: all 1s;
  }
`;
const LinkContainer = styled.a``;
const TriangularContainer = styled.div`
  position: relative;
  margin: 10px;
`;
class NameAndJobTitle extends Component {
  render() {
    return (
      <Container id="home">
        <TriangularContainer>
          <Music />
          <LinkContainer href="https://tivlotcv.com/en/t/3KmgaPWN">
            <ButtonDownload>MY &nbsp; ✦ &nbsp; CV</ButtonDownload>
          </LinkContainer>
        </TriangularContainer>
        <br />
        <br />
        <NameReveal text="Dor Bellmas" fontFam="Valencia" timeDelay={500} />
        <br />
        <br />
        <TitleReveal text="Product Manager & Developer" fontFam="AvenirRoman" timeDelay={1300} />
      </Container>
    );
  }
}

export default NameAndJobTitle;
